import React, { useState, useEffect } from 'react';

// const API_BASE_URL = 'http://localhost:8080';
const API_BASE_URL = 'https://sardar-jewellers.com';

const AdminCartList: React.FC = () => {
    const [cartItems, setCartItems] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    // Popup states
    const [selectedCartItem, setSelectedCartItem] = useState<any | null>(null);
    const [customerDetails, setCustomerDetails] = useState<any>(null);
    const [isLoadingDetails, setIsLoadingDetails] = useState(false);

    useEffect(() => {
        fetchAllCarts();
    }, []);

    const fetchAllCarts = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/cart/all-admin`);
            if (response.ok) {
                const data = await response.json();
                setCartItems(data);
            }
        } catch (error) {
            console.error("Error fetching carts", error);
        } finally {
            setIsLoading(false);
        }
    };

    const openCartDetails = async (item: any) => {
        setSelectedCartItem(item);
        setIsLoadingDetails(true);
        setCustomerDetails(null);

        try {
            // Asli User Data nikal rahe hain calling ke liye
            const userRes = await fetch(`${API_BASE_URL}/api/users/${item.userSrno}`);
            if (userRes.ok) {
                const userData = await userRes.json();
                setCustomerDetails({ 
                    name: userData.userName || "Unknown User", 
                    email: userData.emailId || "Not Provided", 
                    phone: userData.mobileNo || "Not Provided",
                });
            }
        } catch (error) {
            console.error("Error fetching user details", error);
        } finally {
            setIsLoadingDetails(false);
        }
    };

    const closeModal = () => setSelectedCartItem(null);

    if (isLoading) return <div className="p-10 text-center font-bold">Loading Carts...</div>;

    return (
        <div className="p-6 bg-white rounded-lg shadow-md m-4 relative">
            <h2 className="text-2xl font-bold mb-2 text-gray-800">Abandoned Carts List</h2>
            <p className="text-gray-500 mb-6 border-b pb-2">Users ki cart items check karo aur unhe call karke order close karo.</p>
            
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                    <thead className="bg-amber-50 text-amber-800 uppercase text-sm leading-normal">
                        <tr>
                            <th className="py-3 px-6 text-left">Cart ID</th>
                            <th className="py-3 px-6 text-left">User ID</th>
                            <th className="py-3 px-6 text-left">Product</th>
                            <th className="py-3 px-6 text-center">Qty</th>
                            <th className="py-3 px-6 text-right">Price</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-700 text-sm font-light">
                        {cartItems.map((item) => (
                            <tr 
                                key={item.cartId} 
                                onClick={() => openCartDetails(item)}
                                className="border-b border-gray-200 hover:bg-amber-50 cursor-pointer transition"
                            >
                                <td className="py-3 px-6 text-left font-medium">#{item.cartId}</td>
                                <td className="py-3 px-6 text-left font-bold text-gray-800">User: {item.userSrno}</td>
                                <td className="py-3 px-6 text-left flex items-center gap-3">
                                    {item.productImage ? (
                                        <img src={item.productImage} alt="Product" className="w-10 h-10 object-cover rounded-md border" />
                                    ) : (
                                        <span className="w-10 h-10 bg-gray-100 flex items-center justify-center rounded-md border">📦</span>
                                    )}
                                    <span className="font-semibold">{item.productTitle}</span>
                                </td>
                                <td className="py-3 px-6 text-center font-bold">{item.quantity}</td>
                                <td className="py-3 px-6 text-right text-amber-700 font-bold">₹{item.price?.toFixed(2)}</td>
                            </tr>
                        ))}
                        {cartItems.length === 0 && (
                            <tr>
                                <td colSpan={5} className="text-center py-6 text-gray-500">Koi abandoned cart nahi hai.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Popup Modal for Cart Follow-up */}
            {selectedCartItem && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 transition-opacity">
                    <div className="bg-white rounded-2xl shadow-xl w-11/12 max-w-lg overflow-hidden animate-fade-in-up">
                        
                        <div className="bg-amber-700 px-6 py-4 flex justify-between items-center text-white">
                            <h3 className="text-xl font-bold">Cart Follow-up Details</h3>
                            <button onClick={closeModal} className="hover:text-amber-200 text-3xl font-bold transition">&times;</button>
                        </div>

                        <div className="p-6">
                            {isLoadingDetails ? (
                                <p className="text-center py-6 text-gray-500">Loading user details...</p>
                            ) : (
                                <div className="space-y-6">
                                    {/* Actionable Contact Section */}
                                    <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl text-center space-y-2">
                                        <p className="text-sm text-amber-800 uppercase font-bold tracking-wider">Customer Contact</p>
                                        <h4 className="text-2xl font-extrabold text-gray-900">{customerDetails?.name || `User ID: ${selectedCartItem.userSrno}`}</h4>
                                        <p className="text-lg font-bold text-amber-700 flex items-center justify-center gap-2">
                                            📞 {customerDetails?.phone || "Number Not Available"}
                                        </p>
                                        <p className="text-sm text-gray-600">✉️ {customerDetails?.email}</p>
                                        
                                        {customerDetails?.phone && customerDetails?.phone !== "No Number" && customerDetails?.phone !== "Not Provided" ? (
                                            <a href={`tel:${customerDetails.phone}`} className="mt-4 inline-block bg-green-600 text-white px-6 py-2 rounded-full font-bold shadow hover:bg-green-700 transition">
                                                Call Customer Now
                                            </a>
                                        ) : (
                                            <span className="mt-4 inline-block bg-gray-300 text-gray-600 px-6 py-2 rounded-full font-bold cursor-not-allowed">
                                                No Number to Call
                                            </span>
                                        )}
                                    </div>

                                    {/* Product Interest Section */}
                                    <div>
                                        <h4 className="font-bold text-gray-800 border-b pb-2 mb-3">Product in Cart</h4>
                                        <div className="flex items-center gap-4 bg-gray-50 p-3 rounded-lg border">
                                            <div className="w-20 h-20 bg-white border rounded flex items-center justify-center overflow-hidden flex-shrink-0">
                                                {selectedCartItem.productImage ? <img src={selectedCartItem.productImage} alt="Product" className="w-full h-full object-cover" /> : <span className="text-2xl">📦</span>}
                                            </div>
                                            <div>
                                                <p className="font-semibold text-gray-800">{selectedCartItem.productTitle}</p>
                                                <p className="text-sm text-gray-500 mt-1">Product ID: {selectedCartItem.productId}</p>
                                                <p className="text-sm text-gray-500">Quantity: <span className="font-bold text-gray-800">{selectedCartItem.quantity}</span></p>
                                                <p className="font-extrabold text-amber-700 mt-1">₹{(selectedCartItem.price * selectedCartItem.quantity).toFixed(2)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminCartList;